import { isIElementAttachmentsGroup } from "@custom-types/i-elements-type-guards";
import { selectChildDepthFirst, selectProjectLoadingState, selectRootIElement } from "@faro-lotv/project-source";
import { createSelector } from "@reduxjs/toolkit";
/**
 * @returns The externalId value of the selected project root IElement, which is the selected project ID
 */
export const selectRootExternalId = createSelector(selectRootIElement, rootIElement => {
  return rootIElement?.externalId;
});

/**
 * @returns True if the project loading state is `loading`, false otherwise
 */
export const selectIsProjectLoading = createSelector(selectProjectLoadingState, loadingState => {
  return loadingState === "loading";
});

/**
 * Selector to retrieve an attachment group. Attachment group is an iElement with typeHint "Attachments"
 * which is a children of markup iElement.
 *
 * @returns The attachment group of a markup if available
 */
export function markupAttachmentGroupSelector(iElement) {
  return createSelector(selectChildDepthFirst(iElement, isIElementAttachmentsGroup), attachmentGroup => {
    return attachmentGroup;
  });
}

/** Selector to retrieve the world transform cache of all iElements available in the store */
export const worldTransformCacheSelector = createSelector(state => state.iElements, iElementsState => {
  return iElementsState.worldTransformCache;
});